import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import '../../styles/signUpDialog.css'
import InputStyle from '../../assets/InputStyle';
import LoginModal from './LoginModal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { verifyEmailOTP, verifyPhoneOTP } from '../../actions/userAuth';
import CloseIcon from '@mui/icons-material/Close';
import { enqueueSnackbar } from 'notistack';




export default function EnterOtpModal({ addEnterOtpAction, setAddEnterOtpAction, emailToken, phoneToken }) {
  const [addLoginAction, setAddLoginAction] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [phoneOtp, setPhoneOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const closeHandler = (event, reason) => {
    if (reason && reason == "backdropClick")
      return;
    setAddEnterOtpAction(false)
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setLoading(true);
    if (!emailOtp || !phoneOtp) {
      enqueueSnackbar("Please enter valid OTP", { variant: 'warning' });
      setLoading(false);
    } else {
      dispatch(verifyEmailOTP({ emailOtp }, (data) => {
        enqueueSnackbar("OTP Verified! Registration Successful", { variant: 'success' });
        setLoading(false);
      }, (err) => {
        enqueueSnackbar("Email OTP verification failed! please try again", { variant: 'error' });
        console.log(err);
        setLoading(false);
      }, emailToken))

      dispatch(verifyPhoneOTP({ phoneOtp }, (data) => {
        enqueueSnackbar("OTP Verified! Registration Successful", { variant: 'success' });
        setLoading(false);
        setAddLoginAction(true);
        setAddEnterOtpAction(false);
      }, (err) => {
        enqueueSnackbar("Phone OTP verification failed! please try again", { variant: 'error' });
        setLoading(false);
      }, phoneToken))
    }
  }

  return (
    <>
      <Dialog
        open={addEnterOtpAction}
        onClose={closeHandler}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <CloseIcon sx={{ float: 'right', cursor: 'pointer' }} onClick={closeHandler} />
        </DialogTitle>
        <DialogContent >
          <Box px={6} py={3}>
            <Typography

              sx={{ fontWeight: 700, mb: 4, textAlign: 'center', color: '#2544EE', fontSize: 22, fontFamily: 'Inter', }}
              component={'h3'}
            >
              Enter OTP
            </Typography>

            <Stack spacing={4} pt={0}  >

              <InputStyle name="Email OTP" topSpace={true} >
                <input type="text" placeholder="Enter OTP" value={emailOtp} onChange={(e) => setEmailOtp(e.target.value)} style={{color:'black',width:"100%",borderColor:'#BDC4CD'}} />
              </InputStyle>

              <InputStyle name="Mobile Number OTP" topSpace={true} >
                <input type="text" placeholder="Enter OTP " value={phoneOtp} onChange={(e) => setPhoneOtp(e.target.value)} style={{color:'black',width:"100%",borderColor:'#BDC4CD'}} />
              </InputStyle>

              <Button disabled={loading} onClick={handleSubmit} variant="contained" fullWidth sx={{ bgcolor: '#2544EE', width: '100%', borderRadius:2, textTransform:'none', fontSize:16 }}>
                {
                  loading
                    ?
                    <CircularProgress size={24} />
                    :
                    "Submit"
                }
              </Button>

            </Stack>
          </Box>

        </DialogContent>
      </Dialog>
      <LoginModal
        addLoginAction={addLoginAction}
        setAddLoginAction={setAddLoginAction}
      />
    </>
  );
}
